import React, { useEffect, useRef, useState } from "react";
import * as powerbi from "powerbi-client";
import Config from '../../commons/config/Config.js';
import axios from 'axios';
import swal from 'sweetalert'
import { FormattedMessage, useIntl } from 'react-intl';
import { isArray } from "@amcharts/amcharts4/core.js";

export default function PowerBIReport({ endpointPath = "/power-bi/embed-data/transportadoras" }) {
	const intl = useIntl()
	const reportRef = useRef(null);
	const [loading , setLoading] = useState(true);

	const showErrorAlert = () => {
		swal({
			title: intl.formatMessage({ id: 'PowerBIReport.errors_handleError.error_en_configuracion_powerbi', defaultMessage: 'Error en la configuración de PowerBI.' }),
			text: intl.formatMessage({ id: 'PowerBIReport.errors_handleError.contacte_al_administrador', defaultMessage: 'Contacte al administrador.' }),
			icon: "error",
			buttons: {
				confirm: {
					text: intl.formatMessage({ id: 'PowerBIReport.errors_handleError.button_aceptar', defaultMessage: 'Aceptar' }),
					value: true,
					visible: true,
					className: "btn btn-primary",
					closeModal: true
				}
			}
		});
	}

	const showErrorPermisoAlert = () => {
		swal({
			title: intl.formatMessage({ id: 'PowerBIReport.errors_handleError.sin_permiso_para_ver_informe', defaultMessage: 'Sin permiso para ver el informe.' }),
			text: intl.formatMessage({ id: 'PowerBIReport.errors_handleError.contacte_al_administrador', defaultMessage: 'Contacte al administrador.' }),
			icon: "error",
			buttons: {
				confirm: {
					text: intl.formatMessage({ id: 'PowerBIReport.errors_handleError.button_aceptar', defaultMessage: 'Aceptar' }),
					value: true,
					visible: true,
					className: "btn btn-primary",
					closeModal: true
				}
			}
		});
	}

	useEffect(() => {
		let isMounted = true;
		setLoading(true);
		async function loadReport() {
			try {
				const res = await axios.get(
					Config.get('apiUrlBase') + endpointPath,
					{
						headers: {
							"Authorization-Token": localStorage.getItem("token"),
							"Content-Type": "application/json",
						}
					}
				);
				if (!isMounted) return;
				setLoading(false);
				const data = res.data;
				const models = powerbi.models;
				let transportadoras = data.transportadoras;

				let config = {
					type: "report",
					tokenType: models.TokenType.Embed,
					accessToken: data.embedToken,
					embedUrl: data.embedUrl,
					id: data.reportId,
					settings: {
						panes: {
							filters: { visible: false },
							pageNavigation: { visible: true }
						}
					}
				};
				if(isArray(transportadoras)){    
					if(transportadoras.length === 0){
						transportadoras = [-1];
					}
					const filtroTransportadoras = {
						$schema: "http://powerbi.com/product/schema#basic",
						target: {
							table: "movil_transportadora",
							column: "transportadora_id"
						},
						operator: "In",
						values: transportadoras
					};
					config.filters = [filtroTransportadoras];
				}

				const powerbiClient = new powerbi.service.Service(
					powerbi.factories.hpmFactory,
					powerbi.factories.wpmpFactory,
					powerbi.factories.routerFactory
				);

				powerbiClient.embed(reportRef.current, config);
			} catch (error) {
				if (isMounted) {
					if(error.response && error.response.status === 403) {
						showErrorPermisoAlert()
					}else {
						showErrorAlert();
					}
				}
			} finally {
				if (isMounted) setLoading(false);
			}
		}
		loadReport();
		return () => { isMounted = false; };
	}, []);

	if (loading) {
		return (
			<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
				<div className="spinner" style={{ width: 48, height: 48, border: '6px solid #f3f3f3', borderTop: '6px solid #0ABFBC', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
				<style>{`
					@keyframes spin {
						0% { transform: rotate(0deg); }
						100% { transform: rotate(360deg); }
					}
				`}</style>
			</div>
		);
	}

	return <div ref={reportRef} style={{ height: "100vh" }}></div>;
}